import { useLocation } from "react-router-dom";

// Custom hook para verificar o caminho da URL
const useVerificarCaminho = (segmento: string): boolean => {
  const location = useLocation();
  return location.pathname.includes(segmento);
};

// Custom hooks para as diferentes áreas
export const useIsSiteAdminArea = (): boolean => {
  return useVerificarCaminho("site/admin");
};

export const useIsSite = (): boolean => {
  return useVerificarCaminho("site");
};
export const useIsEscolaLegislativo = (): boolean => {
  return useVerificarCaminho("/escola-legislativo");
};

export const useIsSaber = (): boolean => {
  return useVerificarCaminho("saber");
};
